module.exports = __webpack_public_path__ + "img/payment-icon-04.57b64ce9.png";